jQuery(document).ready(function ($) {
    let contact_form = document.getElementById('contact-form');

    // Exit early if form doesn't exist on this page
    if (!contact_form) {
        return;
    }

    let alert_msg = $('#contact-form-alert-message');
    if (alert_msg.length) {
        alert_msg.hide();
    }

    function showAlertMessage(message, isSuccess = true) {
        if (!alert_msg.length) return;

        alert_msg.find('.alert-message').text(message);

        if (isSuccess) {
            alert_msg.removeClass('alert-danger').addClass('alert-success');
        } else {
            alert_msg.removeClass('alert-success').addClass('alert-danger');
        }

        alert_msg.show();
    }

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    $('#contact-form').on('submit', function (event) {
        event.preventDefault();
        let form = $(this);

        if (alert_msg.length) {
            alert_msg.hide();
            alert_msg.find('.alert-message').text('');
        }

        let name = this.name.value;
        let email = this.email.value;
        let phone = this.phone.value;
        let message = this.message.value;
        let recaptcha_response = this.recaptcha_response ? this.recaptcha_response.value : '';

        let errors = [];

        if (!name || !name.trim()) {
            errors.push("Vyplňte prosím své jméno.");
        }

        if (!validateEmail(email)) {
            errors.push("Neplatná e-mailová adresa.");
        }

        if (!message || !message.trim()) {
            errors.push("Vyplňte prosím zprávu.");
        }

        if (errors.length > 0) {
            showAlertMessage(errors[0], false);
            return;
        }

        // AJAX call
        $.ajax({
            type: 'POST', url: MyAjax.ajaxurl, data: {
                action: 'handle_contact_form_submission',
                name: name,
                email: email,
                phone: phone,
                message: message,
                nonce: MyAjax.nonce,
                recaptcha_response: recaptcha_response
            }, success: function (response) {
                if (response.success) {
                    showAlertMessage(response.data, true);
                    form.hide();
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'form_submit',
                        form:  'contact-form',
                        customer: {
                            name: name,
                            email: email,
                            phone: phone,
                            message: message
                        }
                    });
                } else {
                    showAlertMessage(response.data, false);
                }
            }, error: function (xhr, status, error) {
                showAlertMessage(xhr.responseJSON.data, false);
            }
        });
    });
});